const getSelectedClauseId = element =>
  element.closest(".clause-id")?.getAttribute("clauseid");

export default getSelectedClauseId;
